import { render, staticRenderFns } from "./PantallaOtp.vue?vue&type=template&id=42d34d52"
import script from "./PantallaOtp.vue?vue&type=script&lang=js"
export * from "./PantallaOtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports